import script from "./TheFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TheFilter.vue?vue&type=script&setup=true&lang=js"

import "./TheFilter.vue?vue&type=style&index=0&id=6b2d464a&lang=css"

const __exports__ = script;

export default __exports__